export default "__VITE_ASSET__BOZ2qFPz__"